function dispatchError(dispatch, error, type, message) {
  dispatch({
    type,
    payload: {
      error: `${message}: ${error}`
    }
  });
}

export default dispatchError;
